export default __webpack_public_path__ + "static/media/GLMath.bdc71061.webp";